<template>
  <login-form></login-form>
</template>

<script>
import LoginForm from '@/components/auth/LoginForm'
export default {
  name: 'ViewLogin',
  components: {
    LoginForm
  }
}
</script>
